import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { IProductDataV2 } from '@df/catalog/product/product';
import { ProductResource } from '@df/catalog/product/product.resource';
import { Store } from '@df/catalog/store/store';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { Product } from '../../product/product.decorator';
import { SeeRangeInStoreService } from '../see-range-in-store.service';
enum ESeeRangeInStoreStatus {
    available,
    range,
    notAvailable
}
@Component({
    selector: 'see-range-in-store-status',
    templateUrl: './see-range-in-store-status.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, TranslationModule,]
})
export class SeeRangeInStoreStatusComponent implements OnChanges {
    @Input()
    store?: Store;
    @Input()
    product?: Product<IProductDataV2>;
    private status = ESeeRangeInStoreStatus.notAvailable;
    constructor(
        private seeRangeInStoreService: SeeRangeInStoreService,
        private productResource: ProductResource
    ) {}
    ngOnChanges(changes: SimpleChanges): void {
        if (this.storeId && this.productId) {
            if (this.seeRangeInStoreService.getSeeRangeInStoreModel(this.productId, this.storeId)) {
                this.status = ESeeRangeInStoreStatus.available;
            } else {
                const rangeModels = this.rangeId
                    ? this.seeRangeInStoreService
                          .getSeeRangeInStoreRangeModels(this.rangeId, [this.storeId])
                          .filter(i => i.data?.product && i.data.product !== this.productId)
                    : [];
                if (rangeModels?.length) {
                    this.status = ESeeRangeInStoreStatus.range;
                } else {
                    this.status = ESeeRangeInStoreStatus.notAvailable;
                }
            }
        } else {
            this.status = ESeeRangeInStoreStatus.notAvailable;
        }
    }
    get storePhoneNumber(): string | undefined {
        return this.store?.data?.phone;
    }
    get isRange(): boolean {
        return this.status === ESeeRangeInStoreStatus.range;
    }
    get dotColourClass(): string {
        switch (this.status) {
            case ESeeRangeInStoreStatus.available:
                return 'col-3';
            case ESeeRangeInStoreStatus.range:
                return 'col-79';
            default:
                return 'col-2';
        }
    }
    get label(): string {
        switch (this.status) {
            case ESeeRangeInStoreStatus.available:
                return 'Product available to view in store';
            case ESeeRangeInStoreStatus.range:
                return 'Product unavailable at this store, others from this range available to view.';
            default:
                return 'Not available to see in store';
        }
    }
    trackByProductId(index: number, product: Product): number {
        return product.id;
    }
    private get productId(): number | undefined {
        return this.product?.id;
    }
    private get rangeId(): number | undefined {
        return this.product?.data?.nyw_item_range_code_nh;
    }
    private get storeId(): number | undefined {
        return this.store?.id;
    }
}
